
import Swiper from 'swiper/swiper-bundle.js';

$(function () {
	/*
	*/
	$(document).on('click', '.header__nav__bar a', function () {
		$('.header__nav').toggleClass('is_active');
		$('.header__nav__bar').toggleClass('is_active');
		return false;
	})
	/*
	*/
	if ($('.castpage').length) {
		$.ajax({
			type: "GET",
			url: "../assets/json/cast.json", // ファイルパス（相対パス）
			dataType: "json", // ファイル形式
			async: false // 非同期通信フラグ
		}).done(function (json) {
			const castdata = json;
			$(document).on('click', '.castpage__list a', function () {
				let $profile = "";
				let $position = '';
				let $table = '';
				const item = castdata["data"][$(this).data('name')];

				if ($(this).find('.position').length) {
					$position = "<p>出演：" + $(this).find('.position')[0].innerHTML;
					if ($(this).find('.position').data('cycle')) {
						$position += "（" + $(this).find('.position').data('cycle') + "）";
					}
					$position += "</p>";
				} else {
					$position = '';
				}
				if ($(this).find('.corner').length) {
					$position += "<p>コーナー：" + $(this).find('.corner')[0].innerHTML + "</p>";
				}

				if ($(this).data('name') !== 'pengin') {
					for (let index = 0; index < item.length; index++) {
						$table += "<tr><th nowrap>" + item[index]["title"] + "</th><td>" + item[index]["content"] + "</td></tr>";
					}
					$profile = '<div class="castpage__profile"><a href="#close" class="close"><span></span><span></span></a><div class="body">' + $position + '<table>' + $table + '</table></div></div>';
				} else {

					for (let index = 0; index < item.length; index++) {
						$table += '<div class="item"><p>' + item[index]["name"] + '</p><table>';
						for (let data = 0; data < item[index]["data"].length; data++) {
							$table += "<tr><th nowrap>" + item[index]["data"][data]["title"] + "</th><td>" + item[index]["data"][data]["content"] + "</td></tr>";
						}
						$profile = '<div class="castpage__profile"><a href="#close" class="close"><span></span><span></span></a><div class="body">' + $position + '<table>' + $table + '</table></div>';
						$table += '</table></div>';
					}
					$profile = '<div class="castpage__profile"><a href="#close" class="close"><span></span><span></span></a><div class="body">' + $position + $table + '</div></div>';
				}


				$('body').append($profile);
				$('.castpage__profile').fadeIn();
				$('.overlay').fadeIn();
				return false;
			})
			$(document).on('click', '.castpage__profile .close', function () {
				$('.castpage__profile').fadeOut(function () {
					$('.castpage__profile').remove();
				});
				$('.overlay').fadeOut();
				return false;
			})
		}).fail(function () {
		}).always(function () {
		});
	}


	var swiper = new Swiper(".thumbnail", {
		spaceBetween: 10,
		slidesPerView: "auto",
		freeMode: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});
	var swiper2 = new Swiper(".main", {
		spaceBetween: 0,
		effect: "fade",
		thumbs: {
			swiper: swiper,
		},
	});
})
